import { StyleSheet } from 'react-native';
import { bold, fontSizeMediumLarge } from '../../constants/palette';

const styles = StyleSheet.create({
  buttonGroup: {
    alignItems: 'center',
    justifyContent: 'space-between',
  },
  container: {
    flex: 1,
    alignItems: 'center',
    justifyContent: 'center',
  },
  contentContainer: {
    flex: 1,
    marginTop: 20,
  },
  errorContainer: {
    marginTop: 0,
  },
  errorText: {
    textAlign: 'left',
  },
  nextButton: {
    paddingLeft: 40,
  },
  title: {
    fontSize: fontSizeMediumLarge,
    fontWeight: bold,
    paddingBottom: 20,
  },
});

export default styles;
